import React from 'react';
import { Show, TextField, DateField, FunctionField, useTranslate } from 'react-admin';
import LinkField from '../../components/fields/LinkField';
import { GridShowLayout, Grid } from '../../components/wrapper';

export const styles = {
	aside: {
		minWidth: '25em',
		marginLeft: '1em'
	},
	inlineBlock: {
		display: 'inline-flex',
		marginRight: '1rem'
	}
};

const WalletNotificationShow = props => {
	const translate = useTranslate();
	return (
		<Show {...props}>
			<GridShowLayout>
				<Grid container>
					<Grid item xs>
						<TextField source="id" />
						<LinkField source="walletId" type="Wallet" />
						<LinkField source="owner" />
						<DateField source="creationDateTime" showTime />
						<TextField source="notificationComponent" />
						<TextField source="notificationType" />
						<TextField source="notificationSubtype" />
						<LinkField source="notifier" />
						<FunctionField
							source="notifierDetails"
							render={record => (
								<span>{translate('resources.wallets.notifications.identifier')}: {record.notifierDetails.identifier}</span>
							)}
						/>
					</Grid>
					<Grid item xs>
						<TextField source="ipAddress" />
						<TextField source="comment" />
						<TextField source="additionalData" />
					</Grid>
				</Grid>
			</GridShowLayout>
		</Show>
	);
};

export default WalletNotificationShow;
